import { compile } from "path-to-regexp";
const createSimpleFormatter = (path) => (config) => {
  const withoutSlash = path.startsWith("/") ? path.slice(1) : path;
  const url = [withoutSlash];
  if (!config) return `/${url[0]}`;
  const query = config.query ?? new URLSearchParams();
  if (config.params) {
    Object.keys(config.params).forEach((param) => {
      config?.params?.[param] && query.set(param, config.params[param]);
    });
  }
  const qs = query.toString();
  return `/${url.join("/")}${qs ? `?${qs.toString()}` : ""}`;
};
const createRawFormatterFromRoutePattern = (path) => compile(path);
export {
  createRawFormatterFromRoutePattern,
  createSimpleFormatter
};
//# sourceMappingURL=formatter.js.map
